module.exports = __webpack_public_path__ + "img/laboratorio_3-4_512.b7ddd9f9.webp";